// Shared floating composer silhouette, used by the web/Mac composer and RNW.
export const floatingComposerFrame = compact => ({ minHeight: 82, borderRadius: compact ? 10 : 24, borderWidth: 1 });
